import { render } from "./PortalSite.vue?vue&type=template&id=7e129c70"
import script from "./PortalSite.vue?vue&type=script&lang=js"
export * from "./PortalSite.vue?vue&type=script&lang=js"

import exportComponent from "D:\\laragon\\www\\leader-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__